import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'mhe-auth-token';

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuthToken = () => localStorage.removeItem(TOKEN_KEY);

const attachAuthHeader = (config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const apiMultipart = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

// Attach Authorization header from localStorage as a fallback for environments
// where cross-site cookies (samesite=none) are blocked by the browser.
api.interceptors.request.use(attachAuthHeader);
apiMultipart.interceptors.request.use(attachAuthHeader);
